import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import {
  getLanguageDirection,
  getLanguageFromSearch,
  resolveLanguage,
  supportedLanguages,
} from './languages'
import { resources } from './resources'

const updateDocumentLanguage = (language: string) => {
  const resolved = resolveLanguage(language)
  document.documentElement.lang = resolved
  document.documentElement.dir = getLanguageDirection(resolved)
}

i18n.on('languageChanged', updateDocumentLanguage)

void i18n.use(initReactI18next).init({
  resources,
  supportedLngs: [...supportedLanguages],
  lng: getLanguageFromSearch(window.location.search),
  fallbackLng: 'en',
  load: 'currentOnly',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
